var map = {
	"./green-xmas-1.jpg": "6aaa",
	"./green-xmas-10.jpg": "127b",
	"./green-xmas-2.jpg": "48da",
	"./green-xmas-3.jpg": "1e2e",
	"./green-xmas-4.jpg": "6167",
	"./green-xmas-5.jpg": "78c9",
	"./green-xmas-7.jpg": "1fff",
	"./green-xmas-9.jpg": "c695",
	"./green-xmas-scrollyimage1-desktop.jpg": "d171",
	"./green-xmas-scrollyimage1.jpg": "3e3d",
	"./green-xmas-scrollyimage2-desktop.jpg": "29e1",
	"./green-xmas-scrollyimage2.jpg": "f706",
	"./green-xmas-scrollyimage3-desktop.jpg": "d7e2",
	"./green-xmas-scrollyimage3.jpg": "b80e",
	"./grid/green-xmas-6.jpg": "ef59",
	"./grid/green-xmas-8.jpg": "0728",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";